import React, { FC } from 'react';

import clsx from 'clsx';

import styles from './styles.module.css';

export type TypographyProps = {
  children?: React.ReactNode;
  variant?:
  | 'medium'
  | 'small'
  | 'regular'
  | 'xSmall'
  | 'medium_s'
  | 'regular_s'
  | 'small_s'
  | 'xSmall_s'
  | 'xSmall_heading'
  | 'small_heading'
  | 'regular_heading'
  | 'medium_heading'
  | 'large_heading'
  | '2xLarge_heading'
  | '3xLarge_heading'
  | '4xLarge_heading'
  | 'hero_large'
  | 'hero_medium';

align ?: 'left' | 'center' | 'right';
as ?: 'p' | 'div' | 'span';
color ?: string;
} & React.HTMLAttributes<HTMLParagraphElement>;

export const Typography: FC<TypographyProps> = props => {
  const { children, variant = 'regular', align = 'left', as = 'p', className, color } = props;

  const TagProps = {
    children,
    ...props,
    style: {
      color,
      ...props.style
    },
    className: clsx(styles.base, styles[`_${variant}`], styles[`_${align}`], className)
  };
  const Tag = () => {
    switch (as) {
      case 'p':
        return <p {...TagProps} />;
      case 'span':
        return <span {...TagProps} />;
      case 'div':
        return <div {...TagProps} />;
      default:
        return <p {...TagProps} />;
    }
  };
  return <Tag />;
};

export default Typography;
